/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const loginAction = createAction('REFORAL_AUTH_LOGIN');
export const logoutAction = createAction('REFORAL_AUTH_LOGOUT');
export const updateFcmTokenAction = createAction('REFORAL_AUTH_UPDATE_FCM_TOKEN');
export const clearUserTokenAction = createAction('REFORAL_USER_CLEAR_TOKEN');
export const registerAction = createAction('REFORAL_AUTH_REGISTER');
export const getUserDetailsAction = createAction('REFORAL_AUTH_GET_USER_DETAILS');
export const verifyEmailAction = createAction('REFORAL_AUTH_VERIFY_EMAIL');
export const resendVerificationAction = createAction('REFORAL_AUTH_RESEND_VERIFICATION');
export const updateEmailOrMobileAction = createAction('REFORAL_AUTH_UPDATE_EMAIL_OR_MOBILE');

// social
export const loginWithGoogleAction = createAction('REFORAL_AUTH_LOGIN_WITH_GOOGLE');
export const loginWithFacebookAction = createAction('REFORAL_AUTH_LOGIN_WITH_FACEBOOK');
export const loginWithTwitterAction = createAction('REFORAL_AUTH_LOGIN_WITH_TWITTER');
export const loginWithMicrosoftAction = createAction('REFORAL_AUTH_LOGIN_WITH_MICROSOFT');

// forgot password
export const forgotPassSendVerificationCodeAction = createAction('REFORAL_AUTH_FORGOT_PASSWORD_SEND_VERIFICATION_CODE');
export const forgotPassVerifyCodeAction = createAction('REFORAL_AUTH_FORGOT_PASSWORD_VERIFY_CODE');
export const changePasswordAction = createAction('REFORAL_AUTH_CHANGE_PASSWORD');

// initial login - onboarding
export const updateOnboardingStatusAction = createAction('REFORAL_AUTH_UPDATE_ONBOARDING_STATUS');

// register
export const registrationTypeAction = createAction('REFORAL_SET_REGISTRATION_TYPE');
export const setVerificationAccessTokenAction = createAction('REFORAL_SET_VERIFICATION_ACCESS_TOKEN');

export const sendVerificationCodeAction = createAction('REFORAL_AUTH_SEND_VERIFICATION_CODE');
export const verifyCodeAction = createAction('REFORAL_AUTH_VERIFY_CODE');
